var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8197 6.91691L12.5744 2.67164C12.1439 2.24108 11.5583 2 10.9469 2H7.16667C4.31639 2 2 4.31639 2 7.16667V12.3333C2 15.1836 4.31639 17.5 7.16667 17.5H12.3333C15.1836 17.5 17.5 15.1836 17.5 12.3333V8.55304C17.5 7.94165 17.2589 7.35609 16.8283 6.92553L16.8197 6.91691ZM12.1094 4.64362L14.8564 7.39056H13.4872C12.7294 7.39056 12.1094 6.81362 12.1094 6.0989V4.64362ZM12.3247 15.7692H7.15805C5.25499 15.7692 3.7136 14.2278 3.7136 12.3247V7.15805C3.7136 5.25499 5.25499 3.7136 7.15805 3.7136H10.3786V6.0989C10.3786 7.76084 11.7736 9.11279 13.4786 9.11279H15.7605V12.3247C15.7605 14.2278 14.2191 15.7692 12.3161 15.7692H12.3247Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarReportIcon);
export default __webpack_public_path__ + "static/media/SidebarReportIcon.324bc74686f67bad50a2418d989561c0.svg";
export { ForwardRef as ReactComponent };